export function FiveHundred() {
  return (
    <>
      <h2>ERROR 500</h2>
      <h1>We&apos;re sorry, something went wrong!</h1>
    </>
  )
}
